import { render, staticRenderFns } from "./NecessitiesReview.vue?vue&type=template&id=68f84d1a&scoped=true"
import script from "./NecessitiesReview.vue?vue&type=script&lang=js"
export * from "./NecessitiesReview.vue?vue&type=script&lang=js"
import style0 from "./NecessitiesReview.vue?vue&type=style&index=0&id=68f84d1a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68f84d1a",
  null
  
)

export default component.exports